import { atom, type WritableAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import mbc from "~/shared/functions/mbc";
import { mbcStorage } from "~/shared/mbc/mbcStorage";

export type PpmAtom<T> = WritableAtom<T, [update: T | ((prev: T) => T)], void>;

export function ppmAtom<T>(key: string, initialValue: T): PpmAtom<T>;
export function ppmAtom<T>(key: string): PpmAtom<T | undefined>;
export function ppmAtom<T>(key: string, initialValue?: T) {
	if (mbc.isNative()) {
		return atomWithStorage(`ppm-state-${key}`, initialValue, mbcStorage, { getOnInit: true });
	} else {
		return atom(initialValue);
	}
}
